// ---------------------------------------------------------------------------
// Byte formatting, kept pure so it can be unit tested.
// ---------------------------------------------------------------------------

const UNITS = ['B', 'KB', 'MB', 'GB', 'TB'] as const;

/**
 * Decimal units, not binary. The figure is read by a volunteer against the
 * storage number their phone shows them, and both iOS and Android count in
 * decimal -- reporting 2.8 MiB next to the system's 2.9 MB invites a support
 * question with no answer worth giving.
 */
export function formatBytes(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes < 0) return '—';
  if (bytes < 1000) return `${Math.round(bytes)} B`;

  let value = bytes;
  let unit = 0;
  while (value >= 1000 && unit < UNITS.length - 1) {
    value /= 1000;
    unit += 1;
  }

  // One decimal below 10, so a 1.4 MB store does not report as "1 MB".
  const rounded = value < 10 ? value.toFixed(1) : String(Math.round(value));
  return `${rounded} ${UNITS[unit] ?? 'TB'}`;
}
